import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';

import Button from '../../../shared/_TBComponents/Button';
import { downloadSharedWorkoutInitialize } from '../ducks/sharedWorkoutActions';
import iconSet from '../../../shared/images/teambuildr-selection.json';
import Text from '../../../shared/_TBComponents/Text';

const DownloadContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 30px;
`;

const DownloadWrapper = styled('div')`
  background: #ffffff;
  border-radius: 6px;
  height: auto;
  position: relative;
  width: 100%;

  .icon {
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
  }
`;

const ModalContainer = styled('div')`
  align-items: center;
  animation: animatebottom 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  z-index: 1001;

  @keyframes animatebottom {
    from {
      opacity: 0;
      transform: translate(-50%, 100%);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const SelectContainer = styled('div')`
  margin: 20px 0;
  select:focus {
    outline: none;
  }
`;

const StyledSelect = styled('select')`
  border-color: ${({ theme }) => theme.colors.green};
  cursor: pointer;
`;

const StyledOption = styled('option')`
  font-family: Nunito Sans;
  font-size: 14px;
`;

const ModalDownload = ({ closeModal }) => {
  const isDownloading = useSelector((state) => state.sharedWorkout.ui.isDownloading);
  const programData = useSelector((state) => state.sharedWorkout.data.programData);
  const [selectedOption, setSelectedOption] = useState('importedExercises');
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleStartDownload = () => {
    const submissionObj = {
      exerDB: selectedOption === 'importedExercises' ? 1 : 0,
      saveID: programData.savedWorkoutId,
      sharedWorkout: programData.savedWorkoutId,
    };
    dispatch(downloadSharedWorkoutInitialize(submissionObj));
  };

  return (
    <ModalContainer>
      <DownloadWrapper>
        <IcomoonReact className='icon' icon='remove' iconSet={iconSet} onClick={closeModal} size={15} />
        <DownloadContainer>
          <Text styledTextProps={{ fontSize: '18px', fontWeight: '500' }}>
            Download Exercises To
          </Text>
          <SelectContainer>
            <StyledSelect
              onChange={(e) => setSelectedOption(e.target.value)}
              theme={theme}
              value={selectedOption}
            >
              <StyledOption value='importedExercises'>
                Imported Exercises (Recommended)
              </StyledOption>
              <StyledOption value='masterDatabase'>
                Master Database
              </StyledOption>
            </StyledSelect>
          </SelectContainer>
          <Button
            bgColor={theme.colors.green}
            disabled={isDownloading}
            fontSize='14px'
            fullWidth
            isLoading={isDownloading}
            lightSpinner
            name='Start Download'
            noBorder
            onClick={handleStartDownload}
            rounded
            txtColor={theme.colors.white}
            upperCase
          />
        </DownloadContainer>
      </DownloadWrapper>
    </ModalContainer>
  );
};

ModalDownload.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default ModalDownload;
